module.exports = __webpack_public_path__ + "img/Pyrolysis_Tires.f785b32f.jpg";